/* ATTOLLE — en-tête et tiroir de navigation.
   Les chaînes viennent de snippets/attolle-drawer.liquid (donc traduites),
   ce fichier ne fait que les poser dans le DOM.

   Deux pièges traités ici :
   - Horizon remplace les nœuds .menu-drawer et header-actions après hydratation,
     ce qui efface toute modification faite au DOMContentLoaded : d'où l'observateur
     qui rejoue apply() après chaque re-rendu.
   - requestAnimationFrame ne se déclenche pas dans un onglet en arrière-plan :
     on passe par setTimeout, qui lui continue de tourner. */
(function () {
  var D;
  try {
    D = JSON.parse(document.getElementById('attolle-drawer-data').textContent);
  } catch (e) {
    return;
  }

  function el(tag, cls, txt) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (txt != null) n.textContent = txt;
    return n;
  }

  function ctaLink(cls) {
    if (!D.cta || !D.cta.t) return null;
    var a = el('a', cls, D.cta.t);
    a.href = D.cta.u;
    return a;
  }

  /* Les deux liens de langue : même page, autre langue. */
  function langLinks(cls) {
    var nav = el('nav', cls);
    nav.setAttribute('aria-label', D.langLabel);
    [['FR', D.frUrl, 'fr'], ['EN', D.enUrl, 'en']].forEach(function (p) {
      var a = el('a', null, p[0]);
      a.href = p[1];
      a.setAttribute('hreflang', p[2]);
      if (D.locale === p[2]) a.setAttribute('aria-current', 'true');
      nav.appendChild(a);
    });
    return nav;
  }

  /* En-tête : le bouton compte laisse la place au sélecteur de langue,
     puis l'appel à l'action se place entre les langues et le panier. */
  function applyHeader() {
    var actions = document.querySelector('header-actions:not([data-attolle])');
    if (!actions) return;
    actions.setAttribute('data-attolle', '1');

    var lang = langLinks('ahdr-lang');
    actions.insertBefore(lang, actions.firstElementChild);

    var cta = ctaLink('ahdr-cta');
    if (cta) actions.insertBefore(cta, lang.nextSibling);
  }

  /* Tiroir mobile : bloc de service en pied. Les sous-titres par entrée ont été
     retirés le 31/08/2026 — voir le commentaire dans attolle-drawer.liquid. */
  /* Les trois catégories à sous-menu sont rendues par Horizon en <details> avec
     une icône de dépliage. Kevin, 01/09/2026 : « enlever les + avec les sous-menus
     des produits ». Chaque accordéon est donc remplacé par un lien simple vers sa
     collection : un clic et on y est, au lieu d'un clic pour déplier puis un
     second pour choisir.

     L'adresse est prise sur le DERNIER lien du sous-menu — « Voir toutes les
     stations », « Voir tous les panneaux » — qui pointe par convention sur la
     collection de la catégorie. Si ce lien de fin disparaissait d'une entrée, son
     accordéon est laissé tel quel plutôt que de fabriquer une adresse au jugé. */
  function aplatirSousMenus(drawer) {
    Array.prototype.forEach.call(drawer.querySelectorAll('details'), function (det) {
      var som = det.querySelector('summary');
      if (!som) return;
      var liens = det.querySelectorAll('a[href]');
      if (!liens.length) return;
      var cible = liens[liens.length - 1].getAttribute('href');
      if (!cible) return;

      var a = el('a', som.className);
      a.href = cible;
      var txt = som.querySelector('.menu-drawer__menu-item-text');
      a.appendChild(el('span', 'menu-drawer__menu-item-text wrap-text',
                       (txt || som).textContent.trim()));

      var vieux = det.closest('accordion-custom') || det;
      if (vieux.parentNode) vieux.parentNode.replaceChild(a, vieux);
    });
  }

  function applyDrawer() {
    var drawer = document.querySelector('.menu-drawer:not([data-attolle])');
    if (!drawer) return;
    drawer.setAttribute('data-attolle', '1');

    aplatirSousMenus(drawer);

    var slot = drawer.querySelector('.menu-drawer__utility-links');
    if (!slot) {
      slot = el('div', 'menu-drawer__utility-links');
      drawer.appendChild(slot);
    }
    if (slot.getAttribute('data-attolle')) return;
    slot.setAttribute('data-attolle', '1');

    var cta = ctaLink('adrw-cta');
    if (cta) slot.appendChild(cta);

    slot.appendChild(el('p', 'adrw-foot__k', D.footKey));

    var ul = el('ul', 'adrw-foot__links');
    D.links.forEach(function (l) {
      var li = el('li');
      var a = el('a', null, l.t);
      a.href = l.u;
      li.appendChild(a);
      ul.appendChild(li);
    });
    slot.appendChild(ul);

    var note = el('p', 'adrw-foot__note');
    note.appendChild(document.createTextNode(D.note + ' '));
    var mail = el('a', null, D.mail);
    mail.href = 'mailto:' + D.mail;
    note.appendChild(mail);
    slot.appendChild(note);

    slot.appendChild(langLinks('adrw-lang'));
  }

  function apply() {
    applyHeader();
    applyDrawer();
  }

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    setTimeout(function () {
      pending = false;
      apply();
    }, 0);
  }

  schedule();
  document.addEventListener('DOMContentLoaded', schedule);
  window.addEventListener('load', schedule);
  document.addEventListener('click', schedule, true);
  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();


